import React from "react";
import {
    Card,
    CardBody,
    CardFooter,
    CardHeader
} from "reactstrap";

export const AdminHome = () =>
    <Card>
        <CardHeader>
            <h5 className="title">Admin</h5>
        </CardHeader>
        <CardBody>idk</CardBody>
        <CardFooter/>
    </Card>;
